import { ISelectedClientAccountsState } from '@interfaces/models';
import { createSelector } from '@ngrx/store';
import { selectedClientAccountsState } from '@store/selectors/selected-client-accounts/selected-client-accounts.selectors';

import { nullState } from '../common/router.selectors';

export const selectDAOfferNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/tax-filing-retirement',
);

export const selectTaxFilingRetirementNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/risk-quiz-setup',
);

export const selectRiskQuizSetupNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/portfolio-match',
);

export const selectPortfolioMatchNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/risk-quiz-results',
);

export const selectRiskQuizResultsNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/multi-account-enrollment',
);

export const selectMultiAccountEnrollmentNextPage = createSelector(
  nullState,
  () => 'secure/open-choice/investment-strategy',
);

export const selectInvestmentStrategyNextPage = createSelector(
  nullState,
  () => 'secure/minor-transfer/review',
);

export const selectDAEnrollNextPage = createSelector(
  selectedClientAccountsState,
  (selectedAccounts: ISelectedClientAccountsState) => {
    const enrollNextPage =
      selectedAccounts.transactionType == 'EXISTING'
        ? 'secure/minor-transfer/terms/existing'
        : 'secure/minor-transfer/terms/new';

    return enrollNextPage;
  },
);
